import { useState, useEffect, useLayoutEffect } from 'react'
import { stopEvent } from '@aytm/lib/common/func'
import { itemTypeFromEvent } from '@aytm/lib/adnd/ADNDHelpers'

const useDrag = (root, isVisible) => {
  const [isDragging, setIsDragging] = useState(false)

  const onDragLeaveHandler = () => {
    setIsDragging(false)
  }

  const onDragOverHandler = event => {
    const type = itemTypeFromEvent(event)
    if ('sidebar-tag' != type) return

    const rootRect = root.getBoundingClientRect()

    if (
      event.clientY >= rootRect.top &&
      event.clientY <= rootRect.top + rootRect.height &&
      event.clientX >= rootRect.x &&
      event.clientX <= rootRect.x + rootRect.width
    ) {
      setIsDragging(true)

      if (
        event.clientY >= rootRect.top &&
        event.clientY <= rootRect.top + 80 &&
        event.clientX >= rootRect.x &&
        event.clientX <= rootRect.x + rootRect.width
      ) {
        root.scrollBy(0, -10)
      }

      if (
        event.clientY >= rootRect.top + rootRect.height - 80 &&
        event.clientY <= rootRect.top + rootRect.height &&
        event.clientX >= rootRect.x &&
        event.clientX <= rootRect.x + rootRect.width
      ) {
        root.scrollBy(0, 10)
      }
    } else setIsDragging(false)
  }

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('dragover', onDragOverHandler)
    } else {
      onDragLeaveHandler()

      document.removeEventListener('dragover', onDragOverHandler)
    }

    return () => {
      onDragLeaveHandler()

      document.removeEventListener('dragover', onDragOverHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible])

  useLayoutEffect(() => {
    const currentScrollY = window.scrollY

    const preventDocumentScroll = event => {
      stopEvent(event)

      window.scrollTo({ top: currentScrollY, behavior: 'instant' })
      // window.scrollTo({ top: currentScrollY })
    }

    if (isDragging) {
      document.addEventListener('scroll', preventDocumentScroll, true)
      document.addEventListener('dragleave', onDragLeaveHandler)
      document.addEventListener('dragend', onDragLeaveHandler)
    } else {
      document.removeEventListener('scroll', preventDocumentScroll, true)
      document.removeEventListener('dragleave', onDragLeaveHandler)
      document.removeEventListener('dragend', onDragLeaveHandler)
    }

    return () => {
      document.removeEventListener('scroll', preventDocumentScroll, true)
      document.removeEventListener('dragleave', onDragLeaveHandler)
      document.removeEventListener('dragend', onDragLeaveHandler)
    }
  }, [isDragging])
}

export default useDrag
